import * as React from 'react';

import cn from 'classnames';

import { Icon } from '@common/components/Icon';

import { BrandBlock } from '../BrandBlock';

import {
	IBrandBaseLogoScreenProps,
	IBrandBaseLogoScreenState,
} from './types';

import * as s from './BrandBaseLogoScreen.scss';

export class BrandBaseLogoScreen extends React.Component<IBrandBaseLogoScreenProps, IBrandBaseLogoScreenState> {

	render() {
		const {
			downloadFileSizes,
			downloadLinkUrls,
			downloadTitle,
			colorTitle,
			grayScaleTitle,
			icon,
			classNames: {
				card: cardClassName,
			},
			onDownloadButtonClick,
		} = this.props;

		return (
			<div className={s.block}>
				<BrandBlock
					title={colorTitle}
					downloadTitle={downloadTitle}
					downloadFileSize={downloadFileSizes?.color}
					downloadLinkUrl={downloadLinkUrls.color}
					classNames={{
						block: s.brandBlock,
						content: s.blockContent,
					}}
					onDownloadButtonClick={onDownloadButtonClick}
				>
					<Icon
						glyph={icon}
						className={cn(cardClassName, s.card, s.whiteBackground, s.pink)}
						classNameSvg={s.svg}
					/>
					<Icon
						glyph={icon}
						className={cn(cardClassName, s.card, s.blackBackground, s.darkPink)}
						classNameSvg={s.svg}
					/>
				</BrandBlock>

				<BrandBlock
					title={grayScaleTitle}
					downloadTitle={downloadTitle}
					downloadFileSize={downloadFileSizes?.grayScale}
					downloadLinkUrl={downloadLinkUrls.grayScale}
					classNames={{
						content: s.blockContent,
					}}
					onDownloadButtonClick={onDownloadButtonClick}
				>
					<Icon
						glyph={icon}
						className={cn(cardClassName, s.card, s.whiteBackground, s.black)}
						classNameSvg={s.svg}
					/>
					<Icon
						glyph={icon}
						className={cn(cardClassName, s.card, s.blackBackground, s.white)}
						classNameSvg={s.svg}
					/>
				</BrandBlock>
			</div>
		);
	}

}
